import React from 'react'
import { getThemePreviewColor } from '../../utils/themeColors'

const ThemeOption = ({ theme, currentTheme, onSelect }) => {
  const isSelected = currentTheme === theme.class

  return (
    <button
      onClick={() => onSelect(theme.class)}
      className={`w-full px-4 py-3 text-left hover:bg-white/20 transition-all duration-200 flex items-center gap-3 ${
        isSelected ? 'bg-white/30' : ''
      } first:rounded-t-xl last:rounded-b-xl`}
    >
      <div className="flex items-center gap-3 flex-1">
        <ThemePreview themeClass={theme.class} />
        <span className="text-sm" style={{color: 'var(--theme-text-primary)'}}>
          {theme.name}
        </span>
      </div>
      {isSelected && <CheckIcon />}
    </button>
  )
}

const ThemePreview = ({ themeClass }) => (
  <div className="flex gap-1">
    <div
      className="w-3 h-3 rounded-full"
      style={{ backgroundColor: getThemePreviewColor(themeClass, 'primary') }}
    />
    <div
      className="w-3 h-3 rounded-full"
      style={{ backgroundColor: getThemePreviewColor(themeClass, 'secondary') }}
    />
    <div
      className="w-3 h-3 rounded-full"
      style={{ backgroundColor: getThemePreviewColor(themeClass, 'accent') }}
    />
  </div>
)

const CheckIcon = () => (
  <svg className="w-4 h-4 text-green-400" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
  </svg>
)

export default ThemeOption